import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.ts'
import Vuelidate from 'vuelidate'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import axios from 'axios';
import VueSocialSharing from 'vue-social-sharing'
import VueHead from 'vue-head'
import TextareaAutosize from 'vue-textarea-autosize';
import GoogleAuth from '@/config/google_oauth.js'
import VueSocketIO from 'vue-socket.io';
import socketio from 'socket.io-client';
import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faMapMarkerAlt, 
  faListUl, 
  faEllipsisH, 
  faPencilAlt, 
  faTrashAlt, 
  faPlus, 
  faSlidersH, 
  faReply,
  faHeart,
  faExclamationTriangle,
  faSmile,
  faMap,
  faShare
} from '@fortawesome/free-solid-svg-icons';
  
  library.add(
    faMapMarkerAlt, 
    faExclamationTriangle,
    faListUl, 
    faEllipsisH,
    faHeart,
    faPencilAlt, 
    faTrashAlt, 
    faPlus, 
    faSlidersH, 
    faReply, 
    faSmile,
    faMap,
    faShare
  );

const gauthOption = {
  clientId: process.env.VUE_APP_GOAUTH_CLIENT,
  scope: 'profile email',
  prompt: 'select_account'
}
process.env.VUE_APP_NODE_SIDE === 'dev' || !process.env.VUE_APP_GOAUTH_CLIENT ? '' : Vue.use(GoogleAuth, gauthOption);

Vue.use(VueSocialSharing);
Vue.use(TextareaAutosize);


// axios.defaults.withCredentials = true;
axios.defaults.headers.common['Authorization'] = encodeURI(localStorage.getItem('token'));
axios.defaults.baseURL = process.env.VUE_APP_NODE_SIDE === 'dev' ? 'http://localhost:3000' : process.env.VUE_APP_REAL_BACK_SERVER_XI;

createAxiosResponseInterceptor()

// function createAxiosResponseInterceptor() {
//   axios.interceptors.response.use(
//     (response) => response,
//     async (error) => {
//       console.log(error.response,'error');
//       if (error.response.status === 401) {
//         router.push('/login')
//       } else {
//         return Promise.reject(error);
//       }
//     }
//   );
// }
function createAxiosResponseInterceptor() {
  let originalConfig = false;
  axios.interceptors.response.use(
    (response) => {
      store.dispatch('readyForRequests', true)
      return response
    },
    async (error) => {
      console.log(error,'error');
      if (error.code === 'ERR_NETWORK' && !error.config.headers.noError) {
        store.dispatch('addError', {message: 'Нет соединения с сервером'})
      }
      if (error.response.status === 401 && error.response.data === 'You token is not verified!' && !originalConfig) {
        originalConfig = true;
        // return a request
        axios.defaults.headers.common['Refresh'] = encodeURI(localStorage.getItem('refresh'));
        return axios.post('/api/auth/refresh',{}, {withCredentials: true})
        .then(response => {
          localStorage.setItem('refresh', response.data.tokens.refreshToken)
          localStorage.setItem('token', response.data.tokens.accessToken)
          axios.defaults.headers.common['Refresh'] = encodeURI(response.data.tokens.refreshToken);
          axios.defaults.headers.common['Authorization'] = encodeURI(response.data.tokens.accessToken);

          Vue.use(new VueSocketIO({
            debug: process.env.VUE_APP_NODE_SIDE === 'dev',
            connection: socketio.connect(axios.defaults.baseURL, {
                query: {
                    token: response.data.tokens.accessToken
                },
                secure: true
            }),
            options: { 
                autoConnect: true,
                reconnection: true,
                reconnectionAttempts: 10
            }
        }));
          error.config.headers.Authorization = response.data.tokens.accessToken;
          error.config.headers.Refresh = response.data.tokens.refreshToken;
          originalConfig = false
          store.dispatch('readyForRequests', true)
          return axios.request(error.config);
        }).catch(error => {
          // let pathname = window.location.pathname;
          // let redirect = pathname.indexOf('/events') === -1 && pathname.indexOf('/places') === -1;
          store.dispatch('readyForRequests', false)
          error.response.data === 'Your refresh is dead!' ? router.push('/login') : ''
          originalConfig = false
          return Promise.reject(error);
        });
      } else {
        store.dispatch('readyForRequests', false)
        return Promise.reject(error);
      }
    }
  );
}

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.prototype.$moment = moment;
Vue.prototype.$axios = axios;

Vue.config.productionTip = false

Vue.use(Vuelidate)

Vue.use(VueHead)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');